import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

declare const $;

@Directive({
	selector: '[appResizeRight]'
})
export class ResizeRightDirective {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('component') componentData;
	@Input() elementNumber;
	@Output() stopped = new EventEmitter<any>();

	startX = 0;
	x = 0;
	parentWidth = 0;
	mouseDown = false;

	@HostListener('mousedown', ['$event'])
	onMousedown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.startX = event.screenX;
		this.x = 0;
		this.parentWidth = $(this.el.nativeElement).parent()[0].clientWidth;

		this.mouseDown = true;
	}

	@HostListener('document:mousemove', ['$event'])
	onMousemove(event: MouseEvent) {
		if (this.mouseDown) {
			event.preventDefault();
			this.x = event.screenX - this.startX;

			let widthToChange = 0;
			if (this.parentWidth + this.x > 1180) {
				widthToChange = 1180;
			} else {
				widthToChange = this.parentWidth + this.x;
			}

			$(this.el.nativeElement)
				.parent()
				.css({
					width: widthToChange + 'px'
				});
		}
	}

	@HostListener('document:mouseup')
	onMouseup() {
		if (this.mouseDown) {
			this.mouseDown = false;
			if (this.componentData.config.type === 50) {
				this.stopped.emit({ width: this.parentWidth + this.x > 1180 ? 1180 : this.parentWidth + this.x });
			} else if (this.componentData.config.type === 23 && this.componentData.config.version > 1) {
				this.componentData.config.merge_array[this.elementNumber].item_width =
					this.parentWidth + this.x > 1180 ? 1180 : this.parentWidth + this.x;
				this.stopped.emit(this.componentData);
			} else {
				this.componentData.config.item_width = this.parentWidth + this.x > 1180 ? 1180 : this.parentWidth + this.x;
				this.stopped.emit(this.componentData);
			}
		}
	}

	constructor(private el: ElementRef) {}
}
